import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
	standalone: true,
	selector: 'app-goldstar-button',
	templateUrl: './goldstar-button.component.html',
	styleUrls: ['./goldstar-button.component.scss'],
	imports: [CommonModule, MatIconModule, MatButtonModule],
})
export class GoldstarButtonComponent implements OnInit, AfterContentInit {
	@Input() color: string = '#e0e0e0';
	@Input() textColor: string = 'white';
	@Input() icon?: string;
	@Input() imgSrc?: string;
	@Input() elementId?: string;
	@Input() disabled: boolean = false;
	@Input() tooltip: string = '';
	@Input() borderColor: string = 'transparent';
	@Input() boxIcon?: string;
	@Input() customClass: string = '';

	@Output() buttonClicked = new EventEmitter<any>();

	constructor(private elRef: ElementRef) {}

	ngOnInit() {}

	ngAfterContentInit(): void {}

	onButtonClicked(event: any): void {
		if (!this.disabled && this.buttonClicked) {
			this.buttonClicked.emit(event);
		}
	}
}
